/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Viewing_UnconfirmedInputs */

const cs_enum_viewing_unconfirmed = /** @type {(inputs: Enum_Viewing_UnconfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prohlídka nepotvrzena`)
};

const en_enum_viewing_unconfirmed = /** @type {(inputs: Enum_Viewing_UnconfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viewing unconfirmed`)
};

/**
* | output |
* | --- |
* | "Viewing unconfirmed" |
*
* @param {Enum_Viewing_UnconfirmedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_viewing_unconfirmed = /** @type {((inputs?: Enum_Viewing_UnconfirmedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Viewing_UnconfirmedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_viewing_unconfirmed(inputs)
	return cs_enum_viewing_unconfirmed(inputs)
});